import { get, post } from './requests'

export const getNotifications = key => page => get(['notifications'], { key, params: { page } })
export const readNotifications = key => post(['notifications', 'read'], { key })
